import React, { useMemo } from "react";
import { Flex, ItemType, Selector } from "@thenounproject/lingo-core";
import { Inspectable } from "@constants/Inspector";
import { getSharedAttribute } from "./utils";

type Props = {
  inspectables: Inspectable[];
  onUpdateGuideTitle: (title: "DO" | "DON'T", color: "green" | "red") => Promise<void>;
  onUpdateGuideStyle: (displayStyle: "image" | "text_only") => Promise<void>;
};

export const GuideOptions: React.FC<Props> = ({
  inspectables,
  onUpdateGuideTitle,
  onUpdateGuideStyle,
}) => {
  const selectionContainsGuides = inspectables.some(i => i.item?.type === ItemType.guide);

  const guideItems = useMemo(
    () => inspectables.filter(i => i.item?.type === ItemType.guide),
    [inspectables]
  );

  const currentTitle = useMemo(
    () => getSharedAttribute(guideItems, i => i.item?.data?.title),
    [guideItems]
  );

  const currentDisplayStyle = useMemo(
    () =>
      getSharedAttribute(guideItems, i => i.item?.displayProperties?.displayStyle) as
        | "image"
        | "text_only"
        | null,
    [guideItems]
  );

  if (!selectionContainsGuides) return null;

  return (
    <Flex gap="4px">
      <Selector
        flex={1}
        value={currentTitle}
        options={[
          { value: "DO", iconId: "info.checkmark", label: "Do" },
          { value: "DON'T", iconId: "action.close", label: "Don't" },
        ]}
        onChange={val =>
          void onUpdateGuideTitle(val as "DO" | "DON'T", val === "DO" ? "green" : "red")
        }
      />
      <Selector
        flex={1}
        value={currentDisplayStyle}
        options={[
          { value: "image", iconId: "content.file", label: "Image" },
          { value: "text_only", iconId: "content.note", label: "Text" },
        ]}
        onChange={val => void onUpdateGuideStyle(val as "image" | "text_only")}
      />
    </Flex>
  );
};
